var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoom = function SvgLoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.665h-7.018l6.078-3.509-1.335-2.312-6.078 3.509 3.509-6.077L16.843.94l-3.508 6.077V0h-2.67v7.018L7.155.94 4.845 2.275l3.509 6.077-6.078-3.508L.94 7.156l6.078 3.509H0v2.67h7.017L.94 16.843l1.335 2.312 6.077-3.508-3.509 6.077 2.313 1.335 3.509-6.078V24h2.67v-7.017l3.508 6.077 2.312-1.335-3.51-6.078 6.079 3.51 1.335-2.313-6.078-3.509H24v-2.67H24Zm-12 4.966a3.644 3.644 0 1 1 0-7.289 3.644 3.644 0 0 1 0 7.289Z",
    fill: "#625DF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgLoom;